"use client";

// By the time this can be called, the CookieConsentBanner (mounted
// site-wide in app/layout.tsx) has already run its dynamic import and
// called run() — this import just hits the module cache, so
// showPreferences() is expected to be safe to call directly. Still guarded
// with try/catch: if run() hasn't finished yet (confirmed by reading the
// library source — showPreferences() reaches into internal DOM-element
// refs that stay undefined until run() completes, and throws), or the
// dynamic import itself fails (network blocked, offline), fail closed and
// log only, per docs/superpowers/specs/2026-09-13-cookie-consent-design.md's
// "Error handling" section — no user-facing error state.
export async function openCookiePreferences(): Promise<void> {
  try {
    const { showPreferences } = await import("vanilla-cookieconsent");
    showPreferences();
  } catch (error) {
    console.error("openCookiePreferences: failed to open cookie preferences", error);
  }
}
